export default __webpack_public_path__ + "static/media/ratingImg.8837ec91.svg";